import { lessonAdapter, lessonSectionAdapter } from '@/Module/Lesson/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const { selectById: lessonSelectById, selectIds: lessonSelectIds } = lessonAdapter.getSelectors<IState>(
  state => state.lesson,
);

export const {
  selectById: lessonSectionSelectById,
  selectIds: lessonSectionSelectIds,
  selectAll: lessonSectionSelectAll,
} = lessonSectionAdapter.getSelectors<IState>(state => state.lessonSection);

export const { selectById: relatedLessonSectionSelectById, selectIds: relatedLessonSectionSelectIds } =
  lessonSectionAdapter.getSelectors<IState>(state => state.lessonSection.relatedList);
